import { render, staticRenderFns } from "./ContentCompass.vue?vue&type=template&id=b465808a&scoped=true"
import script from "./ContentCompass.vue?vue&type=script&lang=js"
export * from "./ContentCompass.vue?vue&type=script&lang=js"
import style0 from "./ContentCompass.vue?vue&type=style&index=0&id=b465808a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b465808a",
  null
  
)

export default component.exports